import React, { useState, useEffect, useRef } from "react";
import DownArrow from "src/img/arrow-down-sign-to-navigate-light.svg";
import styled from "styled-components";

const ActionsContainer = styled.div`
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: flex-end;
`;

const ActionsButton = styled.button`
    background: #000000;
    color: #ffffff;
    border: none;
    border-radius: 0.6rem;
    width: 7rem;
    height: 2.5rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 14px;
    font-weight: 700;
`;

const Icon = styled.img`
    width: 0.55rem;
    height: 0.5rem;
    margin: 0 0 0.1rem 0.5rem;
`;

function PaymentMethodCardActions({ item, setDefault, deleteItem }) {
    const [hidden, setHidden] = useState(true);
    const actionsRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (actionsRef.current && !actionsRef.current.contains(event.target)) {
                setHidden(true);
            }
        };

        if (hidden === false) {
            document.addEventListener("click", handleClickOutside, true);
        }
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    });

    const handleClick = () => {
        setHidden(!hidden);
    };

    const handleSetDefault = () => {
        setDefault(item);
        setHidden(true);
    };

    const handleDelete = () => {
        deleteItem(item);
        setHidden(true);
    };

    return (
        <ActionsContainer ref={actionsRef}>
            <ActionsButton type="button" onClick={handleClick} aria-expanded={!hidden} aria-haspopup="menu">
                Actions<Icon src={DownArrow} alt="" />
            </ActionsButton>
            {!hidden &&
            <div style={{ position: "relative" }} role="menu">
                <div style={{ width: "9.375rem", border: "1px solid #E9EBEF", borderRadius: "8px", padding: "1em", fontSize: "14px", fontWeight: "500", backgroundColor: "#FFF", position: "absolute", top: "2.5rem", right: "0rem", zIndex: "1" }}>
                    <div style={{ paddingBottom: "0.5em", cursor: "pointer" }} onClick={handleSetDefault}>Set As Default</div>
                    <div style={{ paddingTop: "0.5em", borderTop: "1px solid #E9EBEF", cursor: "pointer" }} onClick={handleDelete}>Delete</div>
                </div>
            </div>
            }
        </ActionsContainer>
    );
}

export default PaymentMethodCardActions;
